// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Satoshi-Variable.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Satoshi-VariableItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: -apple-system, BlinkMacSystemFont, Inter, SF Pro, Segoe UI, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-left-\\[9999px\\] {
  left: -9999px;
}
.-top-8 {
  top: -2rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-\\[15px\\] {
  bottom: 15px;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[10px\\] {
  right: 10px;
}
.right-sidebar {
  right: 280px;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1100\\] {
  z-index: 1100;
}
.z-\\[120\\] {
  z-index: 120;
}
.z-\\[150\\] {
  z-index: 150;
}
.z-\\[160\\] {
  z-index: 160;
}
.z-\\[2000\\] {
  z-index: 2000;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[300\\] {
  z-index: 300;
}
.z-\\[50\\] {
  z-index: 50;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[90\\] {
  z-index: 90;
}
.z-\\[99999999999\\] {
  z-index: 99999999999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.order-last {
  order: 9999;
}
.col-span-full {
  grid-column: 1 / -1;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!h-full {
  height: 100% !important;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[340px\\] {
  height: 340px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[160px\\] {
  max-height: 160px;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[46vh\\] {
  max-height: 46vh;
}
.max-h-\\[640px\\] {
  max-height: 640px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[260px\\] {
  min-height: 260px;
}
.min-h-\\[280px\\] {
  min-height: 280px;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[82px\\] {
  min-height: 82px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[min\\(100vw-2rem\\2c 22rem\\)\\] {
  width: min(100vw - 2rem, 22rem);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[148px\\] {
  min-width: 148px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[72px\\] {
  min-width: 72px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[62px\\] {
  max-width: 62px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-accent {
  border-color: var(--accent);
}
.border-bg-main {
  border-color: var(--bg-main);
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-border {
  border-color: var(--border);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-500\\/60 {
  border-color: rgb(239 68 68 / 0.6);
}
.border-text-disabled {
  border-color: var(--text-disabled);
}
.border-text-primary {
  border-color: var(--text-primary);
}
.border-text-secondary {
  border-color: var(--text-secondary);
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#323232\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(50 50 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(30\\2c 30\\2c 30\\2c 0\\.78\\)\\] {
  background-color: rgba(30,30,30,0.78);
}
.bg-accent {
  background-color: var(--accent);
}
.bg-accent-light {
  background-color: var(--accent-light);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-bg-control {
  background-color: var(--bg-control);
}
.bg-bg-main {
  background-color: var(--bg-main);
}
.bg-bg-panel {
  background-color: var(--bg-panel);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55 {
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-border {
  background-color: var(--border);
}
.bg-green-500\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/20 {
  background-color: rgb(234 179 8 / 0.2);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-black\\/75 {
  --tw-gradient-from: rgb(0 0 0 / 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/20 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.fill-accent {
  fill: var(--accent);
}
.fill-transparent {
  fill: transparent;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-28 {
  padding-left: 7rem;
  padding-right: 7rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[112px\\] {
  padding-right: 112px;
}
.pr-\\[116px\\] {
  padding-right: 116px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.8px\\] {
  letter-spacing: 0.8px;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-accent {
  color: var(--accent);
}
.text-bg-main {
  color: var(--bg-main);
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-text-disabled {
  color: var(--text-disabled);
}
.text-text-primary {
  color: var(--text-primary);
}
.text-text-secondary {
  color: var(--text-secondary);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.placeholder-text-secondary::-moz-placeholder {
  color: var(--text-secondary);
}
.placeholder-text-secondary::placeholder {
  color: var(--text-secondary);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-55 {
  opacity: 0.55;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-2px_0_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: -2px 0 8px rgba(0,0,0,0.1);
  --tw-shadow-colored: -2px 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_2px_var\\(--accent-light\\)\\] {
  --tw-shadow: 0 0 0 2px var(--accent-light);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_var\\(--accent-light\\)\\] {
  --tw-shadow: 0 0 0 4px var(--accent-light);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_var\\(--accent-light\\)\\] {
  --tw-shadow: inset 0 0 0 1px var(--accent-light);
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[-ms-overflow-style\\:none\\] {
  -ms-overflow-style: none;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}

/* Satoshi - Variable font (Fontshare) */
@font-face {
  font-family: 'Satoshi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 300 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Satoshi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 300 900;
  font-style: italic;
  font-display: swap;
}

/* CSS Variables - Pure Minimal Design (Dark theme by default) */
:root {
  --bg-main: #1e1e1e;
  --bg-panel: #2a2a2a;
  --bg-control: #3a3a3a;
  --bg-control-hover: #4a4a4a;
  --border: #404040;
  --text-primary: #e0e0e0;
  --text-secondary: #b0b0b0;
  --text-disabled: #707070;
  --accent: #ffffff;
  --accent-hover: #f5f5f5;
  --accent-light: rgba(255, 255, 255, 0.1);
  --mobile-bottom-nav-height: 56px;
  --mobile-top-module-bar-height: 48px;
  --mobile-prompt-bottom-offset: 56px;
  --mobile-scrollable-reserve: 240px;
  --mobile-packshot-content-reserve: 132px;
  --mobile-empty-state-reserve: 140px;
  --z-mobile-nav: 116;
  --z-mobile-sheet-backdrop: 115;
  --z-mobile-sheet: 120;
  --z-mobile-prompt: 110;
  --z-mobile-drawer-backdrop: 125;
  --z-mobile-drawer: 130;
  --scrollbar-size: 6px;
  --scrollbar-track: transparent;
  --scrollbar-thumb: var(--bg-control);
  --scrollbar-thumb-hover: var(--bg-control-hover);
}

[data-theme="light"] {
  --bg-main: #f5f5f5;
  --bg-panel: #ffffff;
  --bg-control: #f8f8f8;
  --bg-control-hover: #eeeeee;
  --border: #d0d0d0;
  --text-primary: #2a2a2a;
  --text-secondary: #5a5a5a;
  --text-disabled: #9a9a9a;
  --accent: #2a2a2a;
  --accent-hover: #1a1a1a;
  --accent-light: rgba(42, 42, 42, 0.1);
  --scrollbar-thumb: var(--border);
  --scrollbar-thumb-hover: var(--text-disabled);
}

/* Global styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Satoshi', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: var(--bg-main);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  height: 100vh;
  /* Enable momentum scrolling on iOS */
  -webkit-overflow-scrolling: touch;
  position: fixed;
  width: 100%;
}

/* Override for React root */
#root {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  /* Enable momentum scrolling on iOS */
  -webkit-overflow-scrolling: touch;
}

/* Global custom scrollbars - dark/minimal, app-wide */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

*::-webkit-scrollbar {
  width: var(--scrollbar-size);
  height: var(--scrollbar-size);
}

*::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}

*::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: 999px;
  border: 1px solid transparent;
  background-clip: padding-box;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover);
}

*::-webkit-scrollbar-corner {
  background: transparent;
}

/* Hide scrollbar utility */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Disable page transition animations - instant page switches */
main > div {
  animation: none !important;
}

main > div > * {
  animation: none !important;
}

/* System-wide button hover fallback styles (where explicit hover classes are missing) */
@media (hover: hover) {
  button:not(:disabled).bg-accent:hover {
    filter: brightness(0.95);
  }

  button:not(:disabled).bg-bg-control:hover {
    background: var(--bg-control-hover);
  }
}

/* Animations */
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes slide-left {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-up {
  animation: slide-up 0.3s ease-out;
}

.animate-slide-left {
  animation: slide-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Button Styles - Standardized */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 9999px;
  border-width: 1px;
  border-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.btn-sm {
  height: 2rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.btn-md {
  height: 2.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.btn-lg {
  height: 2.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
}

.btn-icon {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 0.5rem;
  padding: 0px;
}

.btn-block {
  width: 100%;
}

.btn-primary {
  background-color: var(--accent);
  color: var(--bg-main);
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (hover: hover) {
  button:not(:disabled).btn-primary:hover {
    filter: brightness(0.95);
  }
}

.btn-primary:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.btn-secondary {
  border-color: var(--border);
  background-color: var(--bg-control);
  color: var(--text-primary);
}

@media (hover: hover) {

  button:not(:disabled).btn-secondary:hover {
    background: var(--bg-control-hover);
  }
}

.btn-secondary:hover {
  background-color: var(--bg-control-hover);
}

.btn-tertiary {
  border-color: var(--border);
  background-color: var(--bg-control);
  color: var(--text-secondary);
}

@media (hover: hover) {

  button:not(:disabled).btn-tertiary:hover {
    background: var(--bg-control-hover);
  }
}

.btn-tertiary:hover {
  background-color: var(--bg-control-hover);
  color: var(--text-primary);
}

.btn-ghost {
  border-color: var(--border);
  background-color: transparent;
  color: var(--text-primary);
}

.btn-ghost:hover {
  background-color: var(--bg-control);
  color: var(--accent);
}

.btn-danger {
  border-color: rgb(239 68 68 / 0.3);
  background-color: rgb(239 68 68 / 0.1);
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.btn-danger:hover {
  border-color: rgb(239 68 68 / 0.5);
  background-color: rgb(239 68 68 / 0.2);
}

.btn-disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.btn-active {
  background-color: var(--accent);
  color: var(--bg-main);
}

@media (hover: hover) {
  button:not(:disabled).btn-active:hover {
    filter: brightness(0.95);
  }
}

/* Module layout primitives */
.module-workspace {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
}
@media (min-width: 768px) {

  .module-workspace {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
  }
}

.module-sidebar-desktop {
  grid-column: span 1 / span 1;
  grid-column-start: 1;
  display: none;
  height: 100%;
  overflow: hidden;
}

@media (min-width: 768px) {

  .module-sidebar-desktop {
    display: block;
  }
}

.module-sidebar-desktop:empty {
  display: none;
}

@media (min-width: 768px) {
  .module-workspace:has(.module-sidebar-desktop:empty) {
    grid-template-columns: minmax(0, 1fr);
  }

  .module-workspace:has(.module-sidebar-desktop:empty) .module-preview-area {
    grid-column: 1 / -1;
  }
}

.module-preview-area {
  display: flex;
  min-width: 0px;
  flex: 1 1 0%;
  overflow-y: auto;
  background-color: var(--bg-main);
}

@media (min-width: 768px) {

  .module-preview-area {
    grid-column: span 1 / span 1;
    grid-column-start: 2;
    overflow: hidden;
  }
}

.module-params-sidebar {
  position: relative;
  height: 100%;
  width: 100%;
  flex-shrink: 0;
  overflow-y: auto;
  background-color: var(--bg-panel);
}

@media (min-width: 768px) {

  .module-params-sidebar {
    width: 280px;
  }
}

.module-mobile-drawer {
  position: fixed;
  inset: 0px;
  height: 100%;
  width: 100%;
  transition-property: transform;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  /* Drawer is fixed inset-0 - safe-area-inset-bottom disabled (was causing gap below tab bar) */
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: 0;
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}

@media (min-width: 768px) {
  
  .module-mobile-drawer {
    padding: 0;
    display: none;
  }
}

.module-mobile-drawer {
  z-index: var(--z-mobile-drawer);
}

.module-mobile-drawer-surface {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  background-color: var(--bg-main);
}

.module-mobile-drawer-header {
  display: flex;
  height: 3rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  border-color: var(--border);
  background-color: var(--bg-panel);
  padding-left: 1rem;
  padding-right: 1rem;
}

.module-mobile-drawer-close-btn {
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: var(--bg-control);
  color: var(--text-primary);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

@media (hover: hover) {

  button:not(:disabled).module-mobile-drawer-close-btn:hover {
    background: var(--bg-control-hover);
  }
}

.module-mobile-drawer-close-btn:hover {
  background-color: var(--bg-control-hover);
}

.module-mobile-drawer-content {
  flex: 1 1 0%;
  overflow-y: auto;
}

.module-mobile-drawer-footer {
  flex-shrink: 0;
  border-top-width: 1px;
  border-color: var(--border);
  background-color: var(--bg-panel);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.module-mobile-drawer-apply-btn {
  width: 100%;
  border-radius: 9999px;
  background-color: var(--accent);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  color: var(--bg-main);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

@media (hover: hover) {
  button:not(:disabled).module-mobile-drawer-apply-btn:hover {
    filter: brightness(0.95);
  }
}

.module-mobile-drawer-apply-btn:hover {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.module-mobile-drawer-backdrop {
  position: fixed;
  inset: 0px;
  background-color: rgb(0 0 0 / 0.5);
}

@media (min-width: 768px) {

  .module-mobile-drawer-backdrop {
    display: none;
  }
}

.module-mobile-drawer-backdrop {
  z-index: var(--z-mobile-drawer-backdrop);
}

/* Mobile Safe Area Support - PWA Standalone Mode */
.pwa-header {
  padding-top: env(safe-area-inset-top, 0px);
  /* Ensure header content doesn't overlap with iOS status bar */
  /* Default for main header (h-12 = 48px) */
  min-height: calc(48px + env(safe-area-inset-top, 0px));
}

/* For mobile drawer headers (h-14 = 56px) - override min-height */
.pwa-header[class*="h-14"],
.pwa-header.h-14 {
  min-height: calc(56px + env(safe-area-inset-top, 0px));
}

.pwa-bottom-nav {
  /* PWA: safe-area-inset-bottom disabled - was causing large gap below tab bar */
  padding-bottom: 0;
}

/* Content area padding to account for fixed header and bottom nav */
.pwa-content {
  /* On mobile: top module bar + safe area, bottom nav spacing */
  padding-top: calc(var(--mobile-top-module-bar-height) + env(safe-area-inset-top, 0px));
  padding-bottom: var(--mobile-bottom-nav-height);
}

/* Gallery (browse) – no extra bottom padding; Gallery + filmstrip handle spacing themselves */
@media (max-width: 767px) {
  .pwa-content.pwa-content-browse {
    padding-bottom: 0;
  }
}

/* Mobile drawer fullscreen container - ensure it respects safe areas */
.pwa-drawer {
  /* Drawer is fixed inset-0 - safe-area-inset-bottom disabled (was causing gap below tab bar) */
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: 0;
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}

/* On desktop, remove safe area padding and use normal layout */
@media (min-width: 768px) {
  .pwa-content {
    padding-top: 0;
    padding-bottom: 0;
  }
  
  .pwa-header {
    min-height: 48px;
    padding-top: 0;
  }
  
  .pwa-header.h-14 {
    min-height: 56px;
    padding-top: 0;
  }
  
  .pwa-bottom-nav {
    min-height: auto;
    padding-bottom: 0;
  }
  
  .pwa-drawer {
    padding: 0;
  }
}

/* Legacy safe area classes - bottom disabled (was causing gap below tab bar) */
.safe-area-bottom {
  padding-bottom: 0;
}

.safe-area-top {
  padding-top: env(safe-area-inset-top);
}

/* Prompt input mobile positioning */
@media (max-width: 767px) {
  .prompt-input-mobile {
    bottom: var(--mobile-prompt-bottom-offset) !important;
  }
}

/* Scrollable preview area - padding so content isn't hidden behind fixed input + tab bar */
@media (max-width: 767px) {
  .scrollable-preview-area {
    padding-bottom: var(--mobile-scrollable-reserve) !important;
  }

  .mobile-packshot-content-reserve {
    padding-bottom: var(--mobile-packshot-content-reserve) !important;
  }

  .mobile-empty-state-reserve {
    padding-bottom: var(--mobile-empty-state-reserve) !important;
  }
}

.mobile-bottom-nav {
  z-index: var(--z-mobile-nav);
}

.mobile-bottom-sheet-backdrop {
  z-index: var(--z-mobile-sheet-backdrop);
}

.mobile-bottom-sheet {
  z-index: var(--z-mobile-sheet);
}

.mobile-prompt-dock {
  z-index: var(--z-mobile-prompt);
}

/* Screen Reader Only - for accessibility */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Prevent iOS auto-zoom on input focus - set font-size to 16px minimum on mobile */
@media screen and (max-width: 767px) {
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="number"],
  input[type="search"],
  input[type="tel"],
  input[type="url"],
  textarea,
  select {
    font-size: 16px !important;
  }
}
.checked\\:bg-accent:checked {
  background-color: var(--accent);
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-accent:hover {
  border-color: var(--accent);
}
.hover\\:border-border:hover {
  border-color: var(--border);
}
.hover\\:border-red-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.hover\\:border-text-disabled:hover {
  border-color: var(--text-disabled);
}
.hover\\:border-text-secondary:hover {
  border-color: var(--text-secondary);
}
.hover\\:border-white\\/60:hover {
  border-color: rgb(255 255 255 / 0.6);
}
.hover\\:bg-accent-hover:hover {
  background-color: var(--accent-hover);
}
.hover\\:bg-bg-control:hover {
  background-color: var(--bg-control);
}
.hover\\:bg-bg-control-hover:hover {
  background-color: var(--bg-control-hover);
}
.hover\\:bg-bg-input:hover {
  background-color: var(--bg-control);
}
.hover\\:bg-bg-panel:hover {
  background-color: var(--bg-panel);
}
.hover\\:bg-black\\/80:hover {
  background-color: rgb(0 0 0 / 0.8);
}
.hover\\:bg-black\\/90:hover {
  background-color: rgb(0 0 0 / 0.9);
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-yellow-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.hover\\:text-accent:hover {
  color: var(--accent);
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-text-primary:hover {
  color: var(--text-primary);
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:brightness-90:hover {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:border-accent:focus {
  border-color: var(--accent);
}
.focus\\:bg-bg-control-hover:focus {
  background-color: var(--bg-control-hover);
}
.focus\\:shadow-\\[0_0_0_2px_var\\(--accent-light\\)\\]:focus {
  --tw-shadow: 0 0 0 2px var(--accent-light);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-bg-control:disabled {
  background-color: var(--bg-control);
}
.disabled\\:text-text-disabled:disabled {
  color: var(--text-disabled);
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}
.disabled\\:opacity-80:disabled {
  opacity: 0.8;
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-accent {
  background-color: var(--accent);
}
.group:hover .group-hover\\:bg-bg-control-hover {
  background-color: var(--bg-control-hover);
}
.group:hover .group-hover\\:text-accent {
  color: var(--accent);
}
.group:hover .group-hover\\:text-bg-main {
  color: var(--bg-main);
}
.group:hover .group-hover\\:text-text-primary {
  color: var(--text-primary);
}
.group\\/icon:hover .group-hover\\/icon\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.peer:hover ~ .peer-hover\\:opacity-100 {
  opacity: 1;
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-accent {
  --tw-ring-color: var(--accent);
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-offset-bg-panel {
  --tw-ring-offset-color: var(--bg-panel);
}
@media (min-width: 640px) {

  .sm\\:inline {
    display: inline;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}
@media (min-width: 768px) {

  .md\\:relative {
    position: relative;
  }

  .md\\:bottom-4 {
    bottom: 1rem;
  }

  .md\\:bottom-6 {
    bottom: 1.5rem;
  }

  .md\\:left-auto {
    left: auto;
  }

  .md\\:right-4 {
    right: 1rem;
  }

  .md\\:right-auto {
    right: auto;
  }

  .md\\:z-auto {
    z-index: auto;
  }

  .md\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-16 {
    height: 4rem;
  }

  .md\\:h-36 {
    height: 9rem;
  }

  .md\\:h-8 {
    height: 2rem;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .md\\:min-h-\\[64px\\] {
    min-height: 64px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-16 {
    width: 4rem;
  }

  .md\\:w-36 {
    width: 9rem;
  }

  .md\\:w-8 {
    width: 2rem;
  }

  .md\\:w-96 {
    width: 24rem;
  }

  .md\\:max-w-5xl {
    max-width: 64rem;
  }

  .md\\:flex-1 {
    flex: 1 1 0%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:rounded-2xl {
    border-radius: 1rem;
  }

  .md\\:p-12 {
    padding: 3rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-44 {
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-4 {
    padding-bottom: 1rem;
  }

  .md\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .md\\:pb-8 {
    padding-bottom: 2rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:pt-4 {
    padding-top: 1rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media (min-width: 1280px) {

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,mFAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,wCAAwC;AACxC;EACE,sBAAsB;EACtB,+DAA2D;EAC3D,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAiE;EACjE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,wCAAwC;EACxC,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,qCAAqC;EACrC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iFAAiF;EACjF,0BAA0B;EAC1B,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wFAAwF;AACxF;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uDAAuD;AACzD;;AAEA,iCAAiC;AAE/B;EAAA,oBAAwI;EAAxI,mBAAwI;EAAxI,uBAAwI;EAAxI,WAAwI;EAAxI,qBAAwI;EAAxI,iBAAwI;EAAxI,yBAAwI;EAAxI,kBAAwI;EAAxI,mBAAwI;EAAxI,mBAAwI;EAAxI,sBAAwI;EAAxI,mBAAwI;EAAxI,oBAAwI;EAAxI,gBAAwI;EAAxI,wBAAwI;EAAxI,wDAAwI;EAAxI;AAAwI;;AAIxI;EAAA,YAAuB;EAAvB,qBAAuB;EAAvB,sBAAuB;EAAvB,kBAAuB;EAAvB;AAAuB;;AAIvB;EAAA,cAAwB;EAAxB,kBAAwB;EAAxB,mBAAwB;EAAxB,mBAAwB;EAAxB;AAAwB;;AAIxB;EAAA,eAA0B;EAA1B,qBAA0B;EAA1B,sBAA0B;EAA1B,eAA0B;EAA1B;AAA0B;;AAI1B;EAAA,eAA6B;EAA7B,cAA6B;EAA7B,qBAA6B;EAA7B;AAA6B;;AAI7B;EAAA;AAAa;;AAIb;EAAA,+BAA2E;EAA3E,qBAA2E;EAA3E,0CAA2E;EAA3E,uDAA2E;EAA3E;AAA2E;;AAA3E;EAAA;IAAA,wBAA2E;EAAA;AAAA;;AAA3E;EAAA,6EAA2E;EAA3E,iGAA2E;EAA3E,uGAA2E;EAA3E,+BAA2E;EAA3E;AAA2E;;AAI3E;EAAA,2BAA8E;EAA9E,mCAA8E;EAA9E;AAA8E;;AAA9E;;EAAA;IAAA,mCAA8E;EAAA;AAAA;;AAA9E;EAAA;AAA8E;;AAI9E;EAAA,2BAAwG;EAAxG,mCAAwG;EAAxG;AAAwG;;AAAxG;;EAAA;IAAA,mCAAwG;EAAA;AAAA;;AAAxG;EAAA,yCAAwG;EAAxG;AAAwG;;AAIxG;EAAA,2BAA2F;EAA3F,6BAA2F;EAA3F;AAA2F;;AAA3F;EAAA,mCAA2F;EAA3F;AAA2F;;AAI3F;EAAA,kCAA+F;EAA/F,sCAA+F;EAA/F,oBAA+F;EAA/F;AAA+F;;AAA/F;EAAA,kCAA+F;EAA/F;AAA+F;;AAI/F;EAAA,mBAAoC;EAApC;AAAoC;;AAIpC;EAAA,+BAA6B;EAA7B;AAA6B;;AAA7B;EAAA;IAAA,wBAA6B;EAAA;AAAA;;AAG/B,6BAA6B;AAE3B;EAAA,aAA0D;EAA1D,YAA0D;EAA1D,WAA0D;EAA1D,sBAA0D;EAA1D;AAA0D;AAA1D;;EAAA;IAAA,aAA0D;IAKxD;EALwD;AAAA;;AAU1D;EAAA,4BAAoE;EAApE,oBAAoE;EAApE,aAAoE;EAApE,YAAoE;EAApE;AAAoE;;AAApE;;EAAA;IAAA;EAAoE;AAAA;;AAGtE;EACE,aAAa;AACf;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAGE;EAAA,aAAqG;EAArG,cAAqG;EAArG,YAAqG;EAArG,gBAAqG;EAArG;AAAqG;;AAArG;;EAAA;IAAA,4BAAqG;IAArG,oBAAqG;IAArG;EAAqG;AAAA;;AAIrG;EAAA,kBAAoF;EAApF,YAAoF;EAApF,WAAoF;EAApF,cAAoF;EAApF,gBAAoF;EAApF;AAAoF;;AAApF;;EAAA;IAAA;EAAoF;AAAA;;AAIpF;EAAA,eAAqG;EAArG,UAAqG;EAArG,YAAqG;EAArG,WAAqG;EAArG,8BAAqG;EAArG,0BAAqG;EAArG,wDAAqG;EAArG,8FAAqG;EAArG,0CAAqG;EAArG,iBAAqG;EAArG,4CAAqG;EAArG;AAAqG;;AAArG;;EAAA;IAAA,UAAqG;IAArG,aAAqG;EAAA;AAAA;;AADvG;EAEE,+BAA+B;AACjC;;AAGE;EAAA,aAA6C;EAA7C,YAA6C;EAA7C,WAA6C;EAA7C,sBAA6C;EAA7C;AAA6C;;AAI7C;EAAA,aAAmG;EAAnG,YAAmG;EAAnG,cAAmG;EAAnG,mBAAmG;EAAnG,8BAAmG;EAAnG,wBAAmG;EAAnG,2BAAmG;EAAnG,iCAAmG;EAAnG,kBAAmG;EAAnG;AAAmG;;AAInG;EAAA,aAAwI;EAAxI,cAAwI;EAAxI,aAAwI;EAAxI,mBAAwI;EAAxI,uBAAwI;EAAxI,qBAAwI;EAAxI,mCAAwI;EAAxI,0BAAwI;EAAxI,+FAAwI;EAAxI,wDAAwI;EAAxI;AAAwI;;AAAxI;;EAAA;IAAA,mCAAwI;EAAA;AAAA;;AAAxI;EAAA;AAAwI;;AAIxI;EAAA,YAA6B;EAA7B;AAA6B;;AAI7B;EAAA,cAAiE;EAAjE,qBAAiE;EAAjE,2BAAiE;EAAjE,iCAAiE;EAAjE,kBAAiE;EAAjE,mBAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,WAAsH;EAAtH,qBAAsH;EAAtH,+BAAsH;EAAtH,kBAAsH;EAAtH,mBAAsH;EAAtH,oBAAsH;EAAtH,uBAAsH;EAAtH,eAAsH;EAAtH,mBAAsH;EAAtH,gBAAsH;EAAtH,qBAAsH;EAAtH,wBAAsH;EAAtH,wDAAsH;EAAtH;AAAsH;;AAAtH;EAAA;IAAA,wBAAsH;EAAA;AAAA;;AAAtH;EAAA,+BAAsH;EAAtH;AAAsH;;AAItH;EAAA,eAA0C;EAA1C,UAA0C;EAA1C;AAA0C;;AAA1C;;EAAA;IAAA;EAA0C;AAAA;;AAD5C;EAEE,wCAAwC;AAC1C;;AAEA,mDAAmD;AACnD;EACE,0CAA0C;EAC1C,8DAA8D;EAC9D,0CAA0C;EAC1C,sDAAsD;AACxD;;AAEA,kEAAkE;AAClE;;EAEE,sDAAsD;AACxD;;AAEA;EACE,+EAA+E;EAC/E,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,8DAA8D;EAC9D,sFAAsF;EACtF,+CAA+C;AACjD;;AAEA,8FAA8F;AAC9F;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uEAAuE;AACvE;EACE,8FAA8F;EAC9F,0CAA0C;EAC1C,iBAAiB;EACjB,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA,+DAA+D;AAC/D;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,+EAA+E;AAC/E;EACE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE;IACE,qDAAqD;EACvD;AACF;;AAEA,2FAA2F;AAC3F;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,iEAAiE;EACnE;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mFAAmF;AACnF;EACE;;;;;;;;;IASE,0BAA0B;EAC5B;AACF;AAtcA;EAAA;AAucA;AAvcA;EAAA,kBAucA;EAvcA,kBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,sBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,kBAucA;EAvcA;AAucA;AAvcA;EAAA,kBAucA;EAvcA;AAucA;AAvcA;EAAA,kBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,kBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,oBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,oBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,gFAucA;EAvcA,oGAucA;EAvcA;AAucA;AAvcA;EAAA,+BAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,0CAucA;EAvcA,qDAucA;EAvcA;AAucA;AAvcA;EAAA,8BAucA;EAvcA;AAucA;AAvcA;EAAA,2GAucA;EAvcA,yGAucA;EAvcA;AAucA;AAvcA;EAAA,iBAucA;EAvcA,iBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,kBAucA;EAvcA,kBAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA,2GAucA;EAvcA,yGAucA;EAvcA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;EAAA;AAucA;AAvcA;;EAAA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA,kBAucA;IAvcA;EAucA;;EAvcA;IAAA,oBAucA;IAvcA;EAucA;;EAvcA;IAAA,iBAucA;IAvcA;EAucA;AAAA;AAvcA;;EAAA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA,iBAucA;IAvcA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA,kBAucA;IAvcA;EAucA;;EAvcA;IAAA,mBAucA;IAvcA;EAucA;;EAvcA;IAAA,mBAucA;IAvcA;EAucA;;EAvcA;IAAA,iBAucA;IAvcA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA,iBAucA;IAvcA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA,mBAucA;IAvcA;EAucA;;EAvcA;IAAA,mBAucA;IAvcA;EAucA;;EAvcA;IAAA,kBAucA;IAvcA;EAucA;AAAA;AAvcA;;EAAA;IAAA;EAucA;;EAvcA;IAAA;EAucA;;EAvcA;IAAA,kBAucA;IAvcA;EAucA;AAAA;AAvcA;;EAAA;IAAA;EAucA;;EAvcA;IAAA;EAucA;AAAA;AAvcA;EAAA;AAucA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Satoshi - Variable font (Fontshare) */\n@font-face {\n  font-family: 'Satoshi';\n  src: url('./fonts/Satoshi-Variable.ttf') format('truetype');\n  font-weight: 300 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Satoshi';\n  src: url('./fonts/Satoshi-VariableItalic.ttf') format('truetype');\n  font-weight: 300 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* CSS Variables - Pure Minimal Design (Dark theme by default) */\n:root {\n  --bg-main: #1e1e1e;\n  --bg-panel: #2a2a2a;\n  --bg-control: #3a3a3a;\n  --bg-control-hover: #4a4a4a;\n  --border: #404040;\n  --text-primary: #e0e0e0;\n  --text-secondary: #b0b0b0;\n  --text-disabled: #707070;\n  --accent: #ffffff;\n  --accent-hover: #f5f5f5;\n  --accent-light: rgba(255, 255, 255, 0.1);\n  --mobile-bottom-nav-height: 56px;\n  --mobile-top-module-bar-height: 48px;\n  --mobile-prompt-bottom-offset: 56px;\n  --mobile-scrollable-reserve: 240px;\n  --mobile-packshot-content-reserve: 132px;\n  --mobile-empty-state-reserve: 140px;\n  --z-mobile-nav: 116;\n  --z-mobile-sheet-backdrop: 115;\n  --z-mobile-sheet: 120;\n  --z-mobile-prompt: 110;\n  --z-mobile-drawer-backdrop: 125;\n  --z-mobile-drawer: 130;\n  --scrollbar-size: 6px;\n  --scrollbar-track: transparent;\n  --scrollbar-thumb: var(--bg-control);\n  --scrollbar-thumb-hover: var(--bg-control-hover);\n}\n\n[data-theme=\"light\"] {\n  --bg-main: #f5f5f5;\n  --bg-panel: #ffffff;\n  --bg-control: #f8f8f8;\n  --bg-control-hover: #eeeeee;\n  --border: #d0d0d0;\n  --text-primary: #2a2a2a;\n  --text-secondary: #5a5a5a;\n  --text-disabled: #9a9a9a;\n  --accent: #2a2a2a;\n  --accent-hover: #1a1a1a;\n  --accent-light: rgba(42, 42, 42, 0.1);\n  --scrollbar-thumb: var(--border);\n  --scrollbar-thumb-hover: var(--text-disabled);\n}\n\n/* Global styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Satoshi', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background: var(--bg-main);\n  color: var(--text-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: hidden;\n  height: 100vh;\n  /* Enable momentum scrolling on iOS */\n  -webkit-overflow-scrolling: touch;\n  position: fixed;\n  width: 100%;\n}\n\n/* Override for React root */\n#root {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  /* Enable momentum scrolling on iOS */\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Global custom scrollbars - dark/minimal, app-wide */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n\n*::-webkit-scrollbar {\n  width: var(--scrollbar-size);\n  height: var(--scrollbar-size);\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb);\n  border-radius: 999px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: var(--scrollbar-thumb-hover);\n}\n\n*::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Hide scrollbar utility */\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* Disable page transition animations - instant page switches */\nmain > div {\n  animation: none !important;\n}\n\nmain > div > * {\n  animation: none !important;\n}\n\n/* System-wide button hover fallback styles (where explicit hover classes are missing) */\n@media (hover: hover) {\n  button:not(:disabled).bg-accent:hover {\n    filter: brightness(0.95);\n  }\n\n  button:not(:disabled).bg-bg-control:hover {\n    background: var(--bg-control-hover);\n  }\n}\n\n/* Animations */\n@keyframes slide-up {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n@keyframes slide-left {\n  from {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.animate-slide-up {\n  animation: slide-up 0.3s ease-out;\n}\n\n.animate-slide-left {\n  animation: slide-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Button Styles - Standardized */\n.btn {\n  @apply px-4 py-2 rounded-full text-sm font-medium transition-all inline-flex items-center justify-center gap-2 border border-transparent;\n}\n\n.btn-sm {\n  @apply h-8 px-3 text-xs;\n}\n\n.btn-md {\n  @apply h-10 px-4 text-sm;\n}\n\n.btn-lg {\n  @apply h-11 px-5 text-base;\n}\n\n.btn-icon {\n  @apply h-9 w-9 p-0 rounded-lg;\n}\n\n.btn-block {\n  @apply w-full;\n}\n\n.btn-primary {\n  @apply bg-accent text-bg-main shadow-sm hover:shadow-md hover:brightness-90;\n}\n\n.btn-secondary {\n  @apply bg-bg-control text-text-primary border-border hover:bg-bg-control-hover;\n}\n\n.btn-tertiary {\n  @apply bg-bg-control text-text-secondary border-border hover:text-text-primary hover:bg-bg-control-hover;\n}\n\n.btn-ghost {\n  @apply bg-transparent text-text-primary border-border hover:text-accent hover:bg-bg-control;\n}\n\n.btn-danger {\n  @apply bg-red-500/10 text-red-500 border-red-500/30 hover:bg-red-500/20 hover:border-red-500/50;\n}\n\n.btn-disabled {\n  @apply opacity-40 cursor-not-allowed;\n}\n\n.btn-active {\n  @apply bg-accent text-bg-main;\n}\n\n/* Module layout primitives */\n.module-workspace {\n  @apply h-full w-full flex flex-col md:grid overflow-hidden;\n}\n\n@media (min-width: 768px) {\n  .module-workspace {\n    grid-template-columns: 280px minmax(0, 1fr);\n  }\n}\n\n.module-sidebar-desktop {\n  @apply hidden md:block col-start-1 col-span-1 h-full overflow-hidden;\n}\n\n.module-sidebar-desktop:empty {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .module-workspace:has(.module-sidebar-desktop:empty) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .module-workspace:has(.module-sidebar-desktop:empty) .module-preview-area {\n    grid-column: 1 / -1;\n  }\n}\n\n.module-preview-area {\n  @apply flex-1 md:col-start-2 md:col-span-1 bg-bg-main overflow-y-auto md:overflow-hidden flex min-w-0;\n}\n\n.module-params-sidebar {\n  @apply h-full w-full md:w-[280px] bg-bg-panel overflow-y-auto flex-shrink-0 relative;\n}\n\n.module-mobile-drawer {\n  @apply md:hidden fixed inset-0 w-full h-full transition-transform duration-300 ease-in-out pwa-drawer;\n  z-index: var(--z-mobile-drawer);\n}\n\n.module-mobile-drawer-surface {\n  @apply w-full h-full bg-bg-main flex flex-col;\n}\n\n.module-mobile-drawer-header {\n  @apply h-12 bg-bg-panel border-b border-border flex items-center justify-between px-4 flex-shrink-0;\n}\n\n.module-mobile-drawer-close-btn {\n  @apply w-10 h-10 flex items-center justify-center bg-bg-control hover:bg-bg-control-hover rounded-lg transition-colors text-text-primary;\n}\n\n.module-mobile-drawer-content {\n  @apply flex-1 overflow-y-auto;\n}\n\n.module-mobile-drawer-footer {\n  @apply bg-bg-panel border-t border-border px-4 py-3 flex-shrink-0;\n}\n\n.module-mobile-drawer-apply-btn {\n  @apply w-full bg-accent text-bg-main px-4 py-3 rounded-full text-base font-semibold hover:brightness-90 transition-all;\n}\n\n.module-mobile-drawer-backdrop {\n  @apply md:hidden fixed inset-0 bg-black/50;\n  z-index: var(--z-mobile-drawer-backdrop);\n}\n\n/* Mobile Safe Area Support - PWA Standalone Mode */\n.pwa-header {\n  padding-top: env(safe-area-inset-top, 0px);\n  /* Ensure header content doesn't overlap with iOS status bar */\n  /* Default for main header (h-12 = 48px) */\n  min-height: calc(48px + env(safe-area-inset-top, 0px));\n}\n\n/* For mobile drawer headers (h-14 = 56px) - override min-height */\n.pwa-header[class*=\"h-14\"],\n.pwa-header.h-14 {\n  min-height: calc(56px + env(safe-area-inset-top, 0px));\n}\n\n.pwa-bottom-nav {\n  /* PWA: safe-area-inset-bottom disabled - was causing large gap below tab bar */\n  padding-bottom: 0;\n}\n\n/* Content area padding to account for fixed header and bottom nav */\n.pwa-content {\n  /* On mobile: top module bar + safe area, bottom nav spacing */\n  padding-top: calc(var(--mobile-top-module-bar-height) + env(safe-area-inset-top, 0px));\n  padding-bottom: var(--mobile-bottom-nav-height);\n}\n\n/* Gallery (browse) – no extra bottom padding; Gallery + filmstrip handle spacing themselves */\n@media (max-width: 767px) {\n  .pwa-content.pwa-content-browse {\n    padding-bottom: 0;\n  }\n}\n\n/* Mobile drawer fullscreen container - ensure it respects safe areas */\n.pwa-drawer {\n  /* Drawer is fixed inset-0 - safe-area-inset-bottom disabled (was causing gap below tab bar) */\n  padding-top: env(safe-area-inset-top, 0px);\n  padding-bottom: 0;\n  padding-left: env(safe-area-inset-left, 0px);\n  padding-right: env(safe-area-inset-right, 0px);\n}\n\n/* On desktop, remove safe area padding and use normal layout */\n@media (min-width: 768px) {\n  .pwa-content {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  \n  .pwa-header {\n    min-height: 48px;\n    padding-top: 0;\n  }\n  \n  .pwa-header.h-14 {\n    min-height: 56px;\n    padding-top: 0;\n  }\n  \n  .pwa-bottom-nav {\n    min-height: auto;\n    padding-bottom: 0;\n  }\n  \n  .pwa-drawer {\n    padding: 0;\n  }\n}\n\n/* Legacy safe area classes - bottom disabled (was causing gap below tab bar) */\n.safe-area-bottom {\n  padding-bottom: 0;\n}\n\n.safe-area-top {\n  padding-top: env(safe-area-inset-top);\n}\n\n/* Prompt input mobile positioning */\n@media (max-width: 767px) {\n  .prompt-input-mobile {\n    bottom: var(--mobile-prompt-bottom-offset) !important;\n  }\n}\n\n/* Scrollable preview area - padding so content isn't hidden behind fixed input + tab bar */\n@media (max-width: 767px) {\n  .scrollable-preview-area {\n    padding-bottom: var(--mobile-scrollable-reserve) !important;\n  }\n\n  .mobile-packshot-content-reserve {\n    padding-bottom: var(--mobile-packshot-content-reserve) !important;\n  }\n\n  .mobile-empty-state-reserve {\n    padding-bottom: var(--mobile-empty-state-reserve) !important;\n  }\n}\n\n.mobile-bottom-nav {\n  z-index: var(--z-mobile-nav);\n}\n\n.mobile-bottom-sheet-backdrop {\n  z-index: var(--z-mobile-sheet-backdrop);\n}\n\n.mobile-bottom-sheet {\n  z-index: var(--z-mobile-sheet);\n}\n\n.mobile-prompt-dock {\n  z-index: var(--z-mobile-prompt);\n}\n\n/* Screen Reader Only - for accessibility */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/* Prevent iOS auto-zoom on input focus - set font-size to 16px minimum on mobile */\n@media screen and (max-width: 767px) {\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"number\"],\n  input[type=\"search\"],\n  input[type=\"tel\"],\n  input[type=\"url\"],\n  textarea,\n  select {\n    font-size: 16px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
